import { Component, ComponentInterface, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'telco-new-price-tag',
  styleUrl: 'telco-new-price-tag.scss',
  shadow: false,
  scoped: true
})
export class TelcoNewPriceTag implements ComponentInterface {
  @Prop() public price: string;
  @Prop() public paymentFreq: string;
  @Prop() public priceDesc: string;
  @Prop() public bundleTitle?: string;

  private withBoldDollarAmounts = (desc: string) => {
    const re = /\$\d+\*?/g;
    return desc.replace(re, (match) => {
      if (match.endsWith('*')) {
        match = match.replace('*', '<sup>*</sup>');
      }
      return `<strong>${match}</strong>`;
    });
  };

  private parsePrice = (price: string) => {
    if (price.endsWith('*')) {
      return `$${parseInt(price, 10)}<sup>*</sup>`;
    }

    return `$${parseInt(price, 10)}`;
  };

  render(): any {
    return (
      <Host>
        <div class={`${this.bundleTitle ? 'bundle' : ''}`}>
          <div class="bundle-tag" hidden={!this.bundleTitle}>
            {this.bundleTitle}
          </div>
          <div class={'price-container'}>
            <div class={`price-value-container`}>
              <span class="price-value" innerHTML={this.parsePrice(this.price)} />
              <br aria-hidden="true" />
              <span>{this.paymentFreq}</span>
            </div>
            <div class={`price-desc ${this.bundleTitle ? 'bundle-price-desc' : ''}`}>
              <div innerHTML={this.withBoldDollarAmounts(this.priceDesc)} /> {/* extra div so flexbox doesn't affect description */}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
